import React from "react";
import { Box, Grid, Paper, Typography } from "@mui/material";
import { BookAppointmentButton } from "components";
// Replace with your own icons
import icon1 from "assets/images/wavelight/icon1.png";
import icon2 from "assets/images/wavelight/icon2.png";
import icon3 from "assets/images/wavelight/icon3.png";

// Background pattern behind cards
import bgLeft from "assets/images/wavelight/bg-pattern.png";
import bgRight from "assets/images/wavelight/bg-pattern-right.png";

// Card internal watermark image (hexagon faint pattern)
import watermark from "assets/images/wavelight/watermark.png"; // Add your hexagon bg pattern here

const data = [
  {
    icon: icon1,
    title: "Standard Vision (20/20)",
    desc: `You can see at 20 feet what most people can see at the same distance — this is considered normal vision clarity.`,
    exp: "Experience - Clear, Normal Vision",
  },
  {
    icon: icon2,
    title: "Below Standard Vision (Weak Eye)",
    desc: `When your vision falls between 20/25 and 20/200, it means you can't see clearly what an average person can at the same distance.`,
    exp: "Experience - Blurred Vision, Glasses Required",
  },
  {
    icon: icon3,
    title: "Beyond Standard Vision (WaveLight Plus)",
    desc: `AI-guided correction can help you achieve 20/15 or even 20/13 — sharper, brighter, and more defined than standard vision.`,
    exp: "Experience - High-Definition, Clear Vision",
  },
];

const WaveLightInfoSection = () => {
  return (
    <Box
      sx={{
        width: "100%",
        py: { md: 12, xs: 8 },
        px: { md: 18, xs: 5 },
        textAlign: "center",
        background: `url(${bgLeft}) no-repeat left top, url(${bgRight}) no-repeat right top`,
        backgroundSize: "32rem, 32rem",
      }}
    >
      {/* === SECTION TITLE === */}
     
      <Typography textAlign="center" variant="subHeader">
                  WaveLight Plus – A Breakthrough In Eye Care
                </Typography>

      {/* Underline below title */}
      

      <Typography
        sx={{
          mt: 2,
          mb: 6,
          fontSize: { md: "16px", xs: "14px" },
          color: "#555",
        }}
      >
        Pushing the Limits of Clarity – Going Beyond 20/20, Helping You See Even Better than Standard Vision
      </Typography>

      {/* === CARDS === */}
      <Grid container spacing={4} justifyContent="center" marginTop={'80px'} marginBottom={'80px'}>
        {data.map((item, i) => (
          <Grid item xs={12} md={4} key={i}>
            <Paper
              elevation={3}
              sx={{
                p: 5,
                pb: 6,
                pt: 8,
                borderRadius: "22px",
                position: "relative",
                minHeight: "290px",
                background: `#fff url(${watermark}) no-repeat top right`,
                backgroundSize: "140px",
              }}
            >
              {/* Floating top icon */}
              <Box
                component="img"
                src={item.icon}
                sx={{
                  width: 80,
                  height: 80,
                  borderRadius: "50%",
                  objectFit: "cover",
                  position: "absolute",
                  top: -40,
                  left: "50%",
                  transform: "translateX(-50%)",
                 
                  
                }}
              />

              <Typography
                sx={{
                  fontWeight: 700,
                  mt: 3,
                  mb: 2,
                  fontSize: "16px",
                }}
              >
                {item.title}
              </Typography>

              <Typography
                sx={{
                  fontSize: "14px",
                  color: "#666",
                  lineHeight: 1.6,
                  px: { lg: 3, xs: 0 },
                }}
              >
                {item.desc}
              </Typography>

              <Typography
                sx={{
                  fontWeight: 700,
                  mt: 3,
                  fontSize: "14px",
                }}
              >
                {item.exp}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
       <BookAppointmentButton /> 
    </Box>
  );
};

export default WaveLightInfoSection;
